import { CSSProperties } from 'react';
import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

import { MOBILE_CONTAINER_WIDTH } from '@mopla/constants';

interface IOwnerState {
	open: boolean;
	withHeader: boolean;
	backgroundColor?: CSSProperties['backgroundColor'];
	zIndex?: number;
}

export const Root = styled('div')<{ ownerState: IOwnerState }>(
	({ ownerState: { open, zIndex } }) => ({
		position: 'absolute',
		width: '100%',
		bottom: 0,
		left: 0,
		top: open ? 0 : '100%',
		transition: 'top .2s',
		zIndex: open ? zIndex || 30 : 10,
	})
);

export const ContentWrapper = styled(Paper)<{ ownerState: IOwnerState }>(
	({ theme, ownerState: { withHeader, backgroundColor } }) =>
		theme.unstable_sx({
			backgroundColor: backgroundColor ?? theme.palette.neutral[0],
			display: 'grid',
			gridTemplateRows: withHeader ? 'max-content 1fr' : '1fr',
			maxWidth: MOBILE_CONTAINER_WIDTH,
			margin: '0 auto',
			height: '100%',
			overflow: 'hidden',
		})
);

export const ChildrenWrapper = styled('div')<{ ownerState: IOwnerState }>(
	() => ({
		overflowY: 'auto',
	})
);
